import axios from 'axios';
const client = "faculty_science";
const token = encodeURIComponent(window.btoa(client));
const headers = {
  'Accept': 'application/json',
  'Content-Type': 'application/json',
  'Authorization': 'Bearer '+token.toString()
}

export default axios.create({
  baseURL: `https://library.science.cmu.ac.th/api/`,
  // baseURL: `http://localhost/science/api/`,
  headers: headers
});